var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.units", [amt_admin]);

var unit_tpl = require('./activity.html');
var units_power_tpl = require('./units_power.html');


app.config([
  "$stateProvider",
  function ($stateProvider) {
    $stateProvider.state("amt.ww2.units", {
      url: "/units",
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: "Units",
        role: "units"
      },
      menu: {
        glyphicon: 'tower',
        childs: [
          {
            state: "amt.ww2.units.units_activity",
            glyphicon: "knight"
          },
          {
            state: "amt.ww2.units.units_power",
            glyphicon: "knight"
          },
        ]
      }
    })
      .state('amt.ww2.units.units_activity', {
        url: '/units_activity',
        template: unit_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: 'Units Activity',
          role: 'units'
        }
      })
      .state('amt.ww2.units.units_power', {
        url: '/units_power',
        template: units_power_tpl,
        reloadOnSearch: false,
        data: {
          priority: 800,
          title: 'Units Power',
          role: 'units',
        },
      })
  }
]);

export default app.name;
